import { useEffect } from "react";

import { consumirEsc, temOverlayAberto } from "../../helpers/escConversa";

// ESC fecha a conversa aberta (igual WhatsApp Web), desde que não tenha nada
// aberto por cima dela. Ver helpers/escConversa.js pras camadas.
//
// O listener fica no `window`, não no `document`: o React 16 delega os eventos no
// `document`, então um `stopPropagation()` feito dentro de um handler React
// (Modal do MUI, Autocomplete, etc.) só barra a propagação a partir dali — o
// `document` já é o alvo corrente e outros listeners nele continuariam rodando.
// No `window`, que é o último da fase de bubbling, o ESC "gasto" nunca chega.
// `ativo` liga só o fechamento da conversa. O listener é montado de qualquer
// forma porque os consumidores (limpar seleção, sair da busca...) também valem
// com a listagem sozinha, sem conversa aberta.
const useEscFecharConversa = ({ ativo, aoFechar }) => {
	useEffect(() => {
		const handleKeyDown = event => {
			if (event.key !== "Escape" || event.defaultPrevented) return;
			if (temOverlayAberto()) return;
			if (consumirEsc(event)) return;
			if (ativo) aoFechar();
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [ativo, aoFechar]);
};

export default useEscFecharConversa;
